import { RegisterUserInput, RegisterUserResult } from "@cruisen/contract"
import { callFirebaseFunction } from "../callFirebaseFunction"
import { saveUserDeviceToken } from "./userDeviceTokens"

export const registerUser = async (payload: RegisterUserInput): Promise<RegisterUserResult> => {
  console.log("create user", { userId: payload.userPayload.id })

  const response = await callFirebaseFunction({
    name: "registerUser",
    payload,
  })
  if (response.error) {
    throw new Error(`User creation failed: ${response.message}`)
  }

  const result = response.data.result

  console.log("User has been created", result.user)

  // new auth token - so re-auth would happen, we don't need to save device token in that case
  if (!result.authToken) {
    await saveUserDeviceToken()
    console.log("device token saved for created user", result.user)
  }

  return result
}
